import { render, staticRenderFns } from "./VerticalPagination.vue?vue&type=template&id=2ae5e04f&scoped=true&"
import script from "./VerticalPagination.vue?vue&type=script&lang=js&"
export * from "./VerticalPagination.vue?vue&type=script&lang=js&"
import style0 from "./VerticalPagination.vue?vue&type=style&index=0&id=2ae5e04f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae5e04f",
  null
  
)

export default component.exports